import React from "react";
import SectionMessage from "@atlaskit/section-message";
import { LoadingButton } from "@atlaskit/button";
import { useMutationUI } from "../../../hooks";
import { UpdateWargameExerciseStatusMutation } from "../../../graphql";
import { wargameExerciseStatuses } from "../../../models";
export var ExecuteExperiments = function (_a) {
    var exerciseId = _a.exerciseId;
    var _b = useMutationUI({
        mutation: UpdateWargameExerciseStatusMutation,
        options: {
            variables: {
                exerciseID: exerciseId,
                status: wargameExerciseStatuses.executeExperiments.name
            }
        },
        successMessage: "You can now start executing experiments"
    }), mutate = _b.mutate, isLoading = _b.isLoading;
    var LinkComponent = function () { return (React.createElement(LoadingButton, { appearance: "primary", isLoading: isLoading, onClick: function () { return mutate(); } }, "Proceed to Execute Experiments")); };
    return (React.createElement(SectionMessage, { title: "Done preparing?", actions: [
            {
                key: "Start execution",
                text: "Start execution",
                href: "#"
            }
        ], linkComponent: LinkComponent }, "You can start executing experiments"));
};
